import { getTenantClient } from '@sazeo/supabase-tenant';
import type { ClaudeChatRequest, ClaudeChatResponse, ClaudeError } from './types';

/**
 * Client-side entry point. Browser callers invoke this and it POSTs to
 * the Edge Function `app/claude-chat`, which does the real Anthropic API
 * call with user's JWT (RLS-aware) and our Anthropic key.
 *
 * This package NEVER holds the Anthropic API key — that lives in Supabase
 * Secrets and is only accessible from Edge Functions.
 *
 * TODO(phase-3): implement streaming via SSE. Today this is a JSON reply.
 */
export const chat = async (req: ClaudeChatRequest): Promise<ClaudeChatResponse | ClaudeError> => {
  const client = getTenantClient();
  const { data, error } = await client.functions.invoke<ClaudeChatResponse | ClaudeError>(
    'app/claude-chat',
    {
      body: req,
    },
  );

  if (error) {
    return {
      code: 'INTERNAL',
      message: error.message,
      retryable: true,
    };
  }
  if (!data) {
    return {
      code: 'INTERNAL',
      message: 'Empty response from claude-chat',
      retryable: true,
    };
  }
  return data;
};
